module.exports = __webpack_public_path__ + "img/bx-arranging-pub.d50a2c42.svg";